export const institutos = {
  'undefined': '',
  '0': 'Itbm',
  '1': '墨西哥 ',
  '2': '中美洲和加勒比',
  '3': '中国与大中华',
  '4': '新加坡',
  '5': '火鸡',
  '6': '菲律宾',
  '7': '厄瓜多尔',
  '8': 'izzi',
  '9': '罗马尼亚',
  '10':'公司人力资源',
  '16': 'Itbm',
  '17': '一项调查',
}


  export const sectores = {
    "1":{
       "NOMBRE":"2.0 航空航天",
       "SUBSECTORES":{
          "1":"2.1 航空航天 // 其他 / 不适用"
       }
    },
    "2":{
       "NOMBRE":"4.0 农业",
       "SUBSECTORES":{
          "1":"4.1 农业 // 其他 / 不适用 "
       }
    },
    "3":{
       "NOMBRE":"5.0 生物技术和制药",
       "SUBSECTORES":{
          "1":"5.1 生物技术与制药 // 生物技术",
          "2":"5.2 生物技术与制药 // 制药",
          "3":"5.3 生物技术和制药 // 其他"
       }
    },
    "4":{
       "NOMBRE":"6.0 建设",
       "SUBSECTORES":{
          "1":"（旧）建筑 // 承包",
          "2":"（旧）建筑 // 基础设施",
          "3":"6.1 施工 // 其他 / 不适用"
       }
    },
    "5":{
       "NOMBRE":"12.0 医疗保健",
       "SUBSECTORES":{
          "1":"(OLD) 医疗保健 // 住院护理服务",
          "2":"12.1 医疗保健 // 医院",
          "3":"12.2 医疗保健 // 医疗用品的销售或分销",
          "4":"12.3 医疗保健 // 专科",
          "5":"(旧) 老年服务 // 家庭护理",
          "6":"(OLD) 老龄化服务 // 住房和老年人护理",
          "7":"(OLD) 医疗 // 其他专业服务",
          "8":"12.4 医疗保健 // 服务",
          "9":"12.5 医疗保健 // 其他",
       }
    },
    "6":{
       "NOMBRE":"7.0 教育培训",
       "SUBSECTORES":{
          "1":"7.1 教育和培训 // 其他 / 不适用"
       }
    },
    "7":{
       "NOMBRE":"13.0 款待",
       "SUBSECTORES":{
          "3":"13.1 款待 // 餐饮服务",
          "2":"13.2 款待 // 酒店/度假村",
          "1":"13.3 款待 // 行政",
          "4":"13.4 款待 // 其他"
       }
    },
    "8":{
       "NOMBRE":"16.0 制造和生产",
       "SUBSECTORES":{
          "28":"16.1 制造和生产 // 替代能源",
          "1":"16.2 制造和生产 // 汽车",
          "15":"16.3 制造和生产 // 基础金属和金属制品",
          "14":"16.4 制造和生产 // 建筑材料",
          "24":"16.5 制造和生产 // 化学品",
          "3":"16.6 制造和生产 // 焦炭、石油衍生物和核燃料",
          "8":"16.7 制造和生产 // 电气、电子和光学设备",
          "6":"16.8 制造和生产 // 电子",
          "7":"16.9 制造和生产 // 能源",
          "5":"16.10 制造和生产 // 能源分配",
          "20":"16.11 制造和生产 // 食品：乳制品和家禽产品",
          "21":"16.12 制造和生产 // 食品：烟草",
          "19":"16.13 制造和生产 // 食品：饮料",
          "18":"16.14 制造和生产 // 食品：其他",
          "16":"16.15 制造和生产 // 家具",
          "10":"16.16 制造和生产 // 汽油/零售",
          "31":"16.17 制造和生产 // 医疗保健",
          "17":"16.18 制造和生产 // 皮革和皮革制品",
          "13":"16.19 制造和生产 // 机械和设备",
          "11":"16.20 制造和生产 // 医疗器械",
          "22":"16.21 制造和生产 // 非金属矿物",
          "2":"16.22 制造和生产 // 个人和家庭护理产品",
          "23":"16.23 制造和生产 // 纸浆、纸张和纸张衍生物",
          "4":"16.24 制造生产//橡塑制品",
          "25":"16.25 制造和生产 // 安全",
          "26":"16.26 制造和生产 // 纺织品和纺织产品",
          "30":"16.27 制造和生产 // 运输设备",
          "29":"16.28 制造和生产 // 供水和处理",
          "12":"16.29 制造和生产 // 木材和木材衍生物",
          "32":"16.30 制造和生产 // 其他",
          "27":"(OLD) 制造和生产 // 快速消费品",
          "9":"（旧）制造和生产 // 医疗保健",
       }
    },
    "9":{
       "NOMBRE":"17.0 媒体",
       "SUBSECTORES":{
          "1":"17.1 媒体 // 出版商和印刷商",
          "4":"17.2 媒体 // 电视/电影/视频",
          "2":"17.3 媒体 // 广播",
          "3":"17.4 媒体 // 互联网服务",
          "5":"17.5 媒体 // 其他",
       }
    },
    "10":{
       "NOMBRE":"18.0 采矿和采石场",
       "SUBSECTORES":{
          "1":"18.1 矿山和采石场 // 其他 / 不适用"
       }
    },
    "11":{
       "NOMBRE":"(OLD) 非营利和慈善组织",
       "SUBSECTORES":{
          "1":"-"
       }
    },
    "12":{
       "NOMBRE":"21.0 零售贸易",
       "SUBSECTORES":{
          "4":"21.1 零售贸易 // 服装/纺织品/鞋类",
          "2":"21.2 零售贸易 // 计算机/电子产品",
          "1":"21.3 零售贸易 // 食品/仓库",
          "5":"21.4 零售贸易 // 电子商务",
          "3":"21.5 零售贸易 // 特色产品",
          "6":"21.6 零售贸易 // 其他",
       }
    },
    "13":{
       "NOMBRE":"11.0 金融服务和保险",
       "SUBSECTORES":{
          "1":"11.1 金融服务和保险 // 投资",
          "9":"11.2 金融服务和保险 // 会计",
          "8":"11.3 金融和保险服务 // 银行/信贷服务",
          "5":"11.4 金融服务和保险 // 健康保险",
          "7":"11.5 金融服务和保险 // 一般保险",
          "6":"11.6 金融服务和保险 // 人寿保险",
          "3":"11.7 金融服务和保险 // 汽车保险",
          "4":"11.8 金融服务和保险 // 家庭保险",
          "2":"11.9 金融服务和保险 // 再保险",
          "10":"11.10 金融服务和保险 // 其他",
       }
    },
    "14":{
      "NOMBRE":"14.0 工业服务",
      "SUBSECTORES":{
        "3":"14.1 工业服务 // 车辆维修和保养",
        "2":"14.2 工业服务 // 工业设计",
        "1":"14.3 工业服务 // 废物/垃圾/回收管理",
        "4":"14.4 工业服务 // 其他",
      }
    },
    "15":{
       "NOMBRE":"19.0 专业服务",
       "SUBSECTORES":{
          "14":"19.1 专业服务 // 广告和营销",
          "2":"19.2 专业服务 // 建筑/设计",
          "5":"19.3 专业服务 // 咨询 - 管理",
          "7":"19.4 专业服务 // 工程咨询",
          "4":"19.5 专业服务 // 环境咨询",
          "8":"19.6 专业服务 // 制造咨询",
          "3":"19.7 专业服务 // 风险评估/精算咨询",
          "11":"19.8 专业服务 // 法律咨询",
          "16":"19.9 专业服务 // 安全",
          "15":"19.10 专业服务 // 人员招聘",
          "6":"19.11 专业服务 // 电话支持 / 销售中心",
          "1":"19.12 专业服务 // 差旅管理",
          "19":"19.13 专业服务 // 其他",
          "12":"(OLD) 专业服务 // 业务流程外包",
          "13":"(OLD) 专业服务 // 业务流程外包 / 呼叫中心",
          "9":"(OLD) 专业服务 // 会计、簿记和审计",
          "17":"(OLD) 专业服务 // 广告营销 / 广告",
          "18":"(OLD) 专业服务 // 广告和营销 / 直销",
          "10":"(OLD) 专业服务 // 教育和培训"
       }
    },
    "16":{
       "NOMBRE":"22.0 社会服务和政府机构",
       "SUBSECTORES":{
          "3":"22.1 社会服务和政府机构 // 商业服务",
          "1":"22.2 社会服务和政府机构 // 文化和艺术",
          "2":"22.3 社会服务和政府机构 // 教育",
          "6":"22.4 社会服务和政府机构……一般公共行政活动",
          "5":"22.5 社会服务和政府机构 // 住房",
          "4":"22.6 社会服务和政府机构 // 人类健康和社会工作",
          "7":"22.7 社会服务和政府机构 // 住宅护理",
          "8":"22.8 社会服务和政府机构 // 其他",
       }
    },
    "17":{
       "NOMBRE":"15.0 信息技术",
       "SUBSECTORES":{
          "3":"15.1 信息技术 // 硬件",
          "4":"15.2 信息技术 // 互联网服务提供商",
          "5":"15.3 信息技术 // 软件",
          "6":"15.4 信息技术 // 互联网服务",
          "1":"15.5 信息技术 // IT 咨询",
          "2":"15.6 信息技术 // 数据存储/管理",
          "7":"15.7 信息技术 // 其他",
       }
    },
    "18":{
       "NOMBRE":"24.0 交通",
       "SUBSECTORES":{
          "2":"24.1 运输 // 航空公司 / 商业航空",
          "1":"24.2 运输 // 包裹运输",
          "3":"24.3 运输 // 陆路和海路旅客运输",
          "4":"24.4 运输 // 运输和储存",
          "5":"24.5 运输 // 其他",
       }
    },
    "19":{
       "NOMBRE":"23.0 电信",
       "SUBSECTORES":{
          "1":"23.1 电信 // 其他 / 不适用"
       }
    },
    "20":{
       "NOMBRE":"8.0 电子产品",
       "SUBSECTORES":{
          "1":"8.1 电子产品 // 其他 / 不适用"
       }
    },
    "21":{
       "NOMBRE":"9.0 工程",
       "SUBSECTORES":{
          "1":"9.1 工程 // 其他 / 不适用"
       }
    },
    "22":{
       "NOMBRE":"10.0 娱乐",
       "SUBSECTORES":{
          "3":"10.1 娱乐 // 表演艺术和观众体育",
          "2":"10.2 娱乐 // 博物馆",
          "1":"10.3 娱乐 // 乐趣和机会游戏",
          "4":"10.4 娱乐 // 其他",
       }
    },
    "23":{
       "NOMBRE":"20.0 房地产",
       "SUBSECTORES":{
          "1":"20.1 房地产 // 住房",
          "2":"20.2 房地产 // 物业管理",
          "3":"20.3 房地产 // 其他",
       }
    },
    "24":{
       "NOMBRE":"25.0 其他",
       "SUBSECTORES":{
          "1":"25.1 其他/不适用"
       }
    },
    "25": {
      "NOMBRE":"3.0 长者服务",
      "SUBSECTORES": {
        "1":"3.1 养老服务 // 住房和养老",
        "2":"3.2 长者服务 // 居家护理",
        "3":"3.3 老年人服务 // 其他",
      }
    }
}

  export const ranking = {
    '1': {
      'NOMBRE': '是啊',
      'TIPO': {
        '1': '小于50',
        '2': '50至500名跨国公司',
        '3': '50至500家跨国公司',
        '4': '大（500至4999)',
        '5': '5000以上'
        // '6': '公共部门',
        // '7': '不参加排名',
        // '8': 'Culture Audit'
      }
    },
    '2': {
      'NOMBRE': '没有啦',
      'TIPO': {
        '1': '小于50',
        '2': '50至500名跨国公司',
        '3': '50至500家跨国公司',
        '4': '大（500至4999)',
        '5': '5000以上'
      }
    },
    'Nacional': '国家的',
    'Multinacional': '跨国'
  }

  export const productos = {
    '1': '证明',
    '2': '测量',
    '3': '035号',
    '4': '脉冲检查',
    '5': '记录员NOM-035',
    '6': '重点地区',
    '7': '文件管理器',
    '8': '文化审核',
    '9': '文化审核v2',
    '10': '文化审核培训',
    '11': '增强测量',
    '12': '测量+ MST',
    '13': '按区域测量',
    '14': '领导测量',
    '15': '按尺寸测量',
    '16': '认证措',
    '17': '结果',
    '19': '更好NOM-035',
    '20': '认证v2.0',
    '21': '全球结果',
    '22': '4ALL实践单结果',
    '23': '完成结果',
    '24': '银包',
    '25': '金包',
    '26': '白金包',
    '37':'文化審核SP',
    '40': '认证v3.0（BETA）',
    '41': '测量v3.0（BETA）',
    '42': '脉冲检查v3.0 (BETA)',
    '43': '焦点区域v3.0',
    '50': '文化审计 5.0',
    '51': '4ALL 文化评估',
    'CULTUREGOEXPRESS':'Cultural Go Express',
    '53':'领袖GO',
    '54':'Action GO',
    '56': 'AMCO',
    '57': '体面的工作',
    '58':'第一份工作',
    'ENCUESTA':'附加认证',
    '60':'认证（进口）',
    '61':'文化简报',
    '62':'文化审核',
    '63': 'NOM-035 v3.0',
    '64':'SP 2022',
    '65':'文化审计 GoFlow 2 2022',
    '66':'文化审核标准 1',
    '67':'文化审计® CA&C',
    '69': '证明银牌',
    '70':'GoFlow 结果',
    '71':'文化审核（认证）2022',
   '72':'文化审计（认证, rkg.） 2022',
   '73':'文化审计（认证, rkg. y adic.） 2022',
   '68':'Swift',
   '76':'文化审计（认证,rkg. y adic.) 2024',
   '77':'文化简报（认证）2024',
   '78':'文化审计（认证和排名）2024',

  }
  export const productosTurquia ={
    '1': '证明',
    '2': '测量',
    '3': '035号',
    '4': '脉冲检查',
    '5': '记录员NOM-035',
    '6': '重点地区',
    '7': '文件管理器',
    '8': '文化审核',
    '9': '文化简介和文化审核5.0',
    '10': '文化审核培训',
    '11': '增强测量',
    '12': '测量+ MST',
    '13': '按区域测量',
    '14': '领导测量',
    '15': '按尺寸测量',
    '16': '认证措',
    '17': '结果',
    '19': '更好NOM-035',
    '20': '认证v2.0',
    '21': '全球结果',
    '22': '4ALL实践单结果',
    '23': '完成结果',
    '24': '银包',
    '25': '金包',
    '26': '白金包',
    '28': '文化简介5.0',
    '29': '文化审核5.0',
    '34': '结果5.0版本3.1',
    '35': '结果5.0版本3.2',
    '36': '结果5.0版本3.3',
    '38': '文化审核行动计划',
    '40': '认证v3.0（BETA）',
    '41': '测量v3.0（BETA）',
    '42': '脉冲检查v3.0 (BETA)',
    '43': '焦点区域v3.0',
    '60':'认证（进口）',
    '54':'Action GO',
    '74':'厄泽尔·李斯特',

  }
  export const categorias = {
    'Certify': '认证产品',
    'Measure': '测量产品',
    'Norm 35': 'NOM-035产品',
    'Pulse Check': '脉冲检查产品',
    'Focus Area': '重点领域产品',
    'Drive': '文件管理器',
    'Culture Audit': '文化审核产品',
    'Resultados': '结果的产品',
    'Resultados 4 ALL': '4ALL产品',
    'Resultados 5.0': '结果5.0产品',
    'Culture Audit Action Plan':'行动计划',
    'Leader GO':'领袖GO',
    'Action GO':'Action GO',
    'Certify Amco':'附加认证',
    'PRODUCTOS_ICCA':'ICCA products',
    'Resultados  V2 HK':'认证（进口）',
    'Swift':'Swift',
  }

  export const niveles = {
    '1': '公司',
    '2': '管理员',
    '3': '一世Ť乙中号',
    '4': '结果',
    '5': '细分结果',
    '8': '文化审核产品',
    '9':'结果 5.0',
    '11': '伊齊',
    '12': 'ActionGo',
    '13': '细分结果和ActionGo',
    '14': 'ActionGo负责人',
    '15': '用户行动领先者',
    '17': '斯威夫特批发商',
    '18': '网络公司简介',
    '19': '结果 2.0',
  }

  export const regiones = {
    '1': '加勒比海',
    '2': '中美洲',
    '3': '中美洲和加勒比',
    '4': '八角地区',
    '5': '中央区域',
    '6': '中西部地区',
    '7': '中南部地区',
    '8': '东北地区',
    '9': '西北地区',
    '10': '东南地区',
    '11':'香港',
    '12':'台湾',
    '13':'中国大陆',
    '14':'大中华',
    '15':'土耳其',
  }
  export const plantillas = {
    '5d826095d06d596a84de6315': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
    },

    '5dcb61e940fb582bc44adf49': {
      'NOMBRE':'TR_ESTANDAR'
    },

    '5dcc946633e1ff000870107e': {
      'NOMBRE':'04_ENGLISH_JAPAN'
    },

    '5dcdd9fd33e1ff1aacf6f04f': {
      'NOMBRE':'01_NORM035_ES_EN_-50'
    },

    '5ddc3fa4f323d727d09870ad': {
      'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
    },

    '5de58de640fb582e0c18d730': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
    },

    '5de69aa4a943da3efc4d0fa6': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_PULSECHECK'
    },

    '5de9498fa943da3efc4d0fa8': {
      'NOMBRE':'05_ING_ESTANDAR'
    },

    '5df820df65e4986b14d1f71c': {
      'NOMBRE':'01_NORM035_ES_EN_+50'
    },

    '5dfc26cec8800d5188a18875': {
      'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
    },

    '5e166105d06d595eb04dca00': {
      'NOMBRE':'Focus_Estandar'
    },

    '5e1754a5f323d72aac6d8726': {
      'NOMBRE':'TR TI + EVP + GPTW LEADER'
    },

    '5e17930b65e4983a3016a4ed': {
      'NOMBRE':'TR TI + EVP'
    },

    '5e2100c6f323d721045812c5': {
      'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
    },

    '5e21042ff323d721045812c6': {
      'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
    },

    '5e210575f323d721045812c7': {
      'NOMBRE':'04_ESP_GOBIERNO'
    },

    '5e2b6dbdc8800d52f45fc248': {
      'NOMBRE':'TEMPLATE 10 PREGUNTAS ESP'
    },

    '5e2f72c8c8800d3398c463a4': {
      'NOMBRE':'CAYC_GOBIERNO'
    },

    '5e3c59b5b473cb6d3e40f902': {
      'NOMBRE':'ING_RUMANO_ESTANDAR'
    },

    '5e697232b473cb6d3e84d87d': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
    },

    '5e6972f3b473cb6d3e84e1e0': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR1'
    },

    '5e697302b473cb6d3e84e2a3': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR2'
    },

    '5e697311b473cb6d3e84e364': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR3'
    },

    '5e697329b473cb6d3e84e490': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR4'
    },

    '5e69734fb473cb6d3e84e656': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR5'
    },

    '5e697367b473cb6d3e84e791': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR6'
    },

    '5e738efbb473cb6d3e8c3915': {
      'NOMBRE':'ESP_CAYC_Diversidad'
    },

    '5e86487eb473cb6d3e09cc42': {
      'NOMBRE':'01_NORM035_ES_EN_-50'
    },

    '5e864896b473cb6d3e09cde1': {
      'NOMBRE':'01_NORM035_ES_EN_+50'
    },

    //PLANTILLAS DE CERTIFICAR 2.0
      '5e960018b473cb6d3ec5f935': {
        'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
      },

      '5e96007cb473cb6d3ec60098': {
        'NOMBRE':'TR_ESTANDAR'
      },

      '5e9600a6b473cb6d3ec603c7': {
        'NOMBRE':'04_ENGLISH_JAPAN'
      },

      '5e9600f0b473cb6d3ec6095a': {
        'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
      },

      '5e960116b473cb6d3ec60c2f': {
        'NOMBRE':'05_ING_ESTANDAR'
      },

      '5e96039fb473cb6d3ec64310': {
        'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
      },

      '5e9603d7b473cb6d3ec6485e': {
        'NOMBRE':'TR TI + EVP + GPTW LEADER'
      },

      '5e9604f7b473cb6d3ec66540': {
        'NOMBRE':'TR TI + EVP'
      },

      '5e960525b473cb6d3ec66a3f': {
        'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
      },

      '5e960549b473cb6d3ec66e30': {
        'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
      },

      '5e96056ab473cb6d3ec671f1': {
        'NOMBRE':'04_ESP_GOBIERNO'
      },

      '5e9605b5b473cb6d3ec67a55': {
        'NOMBRE':'CAYC_GOBIERNO'
      },

      '5e9605e0b473cb6d3ec67f3c': {
        'NOMBRE':'ING_RUMANO_ESTANDAR'
      },

      '5e96060fb473cb6d3ec684d8': {
        'NOMBRE':'ESP_CAYC_Diversidad'
      },
      '5f84a2fab473cb6d3e017c0d': {
        'NOMBRE':'ESP_ESTANDAR_IDIOMAS'
      },
      '5f733fcab473cb6d3e19d56c': {
        'NOMBRE':'04_ESP_Gobierno_MX'
      },
      // pendiente TK
      '5e14fc2cf323d72aac6d8722': {
        'NOMBRE':' '
      },
      // pendiente TK
      '5e14fcc4f323d72aac6d8723': {
        'NOMBRE':' '
      },
      // pendiente MX
      '5d71b21db11f333a30de813e': {
        'NOMBRE':' '
      },
      '5fcebf59c1057065a70fe712':{
        'NOMBRE':'TR_ESTANDAR_+COVID v2'
      },
      '6046a10e7308ab51607f95b5':{
        'NOMBRE':''
      }
  }

  export const answer = {
    '1': '文化围棋调查',
    '2': '纸',
    '3': '短信',
    '4': '亭',
    '5': '不适用',
  }
